const firebaseConfig = {
    apiKey: "AIzaSyDIxIJlwwMVac5PxVBqoebfPbQES-vcfdw",
    authDomain: "ride-share-1459b.firebaseapp.com",
    projectId: "ride-share-1459b",
    storageBucket: "ride-share-1459b.appspot.com",
    messagingSenderId: "213446199865",
    appId: "1:213446199865:web:fac117971b4e1dd2af1be8"
  };

export default firebaseConfig; 